// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"42345cbf","266":"583017c0","453":"cd50d4bc","509":"fe662b69","594":"22f3f061","808":"8beec086","957":"a6d2414c"}[chunkId] + ".chunk.js";
};